import { render, staticRenderFns } from "./studyGardens.vue?vue&type=template&id=0cfb0a6e&scoped=true&"
import script from "./studyGardens.vue?vue&type=script&lang=js&"
export * from "./studyGardens.vue?vue&type=script&lang=js&"
import style0 from "./studyGardens.vue?vue&type=style&index=0&lang=less&"
import style1 from "./studyGardens.vue?vue&type=style&index=1&id=0cfb0a6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfb0a6e",
  null
  
)

component.options.__file = "studyGardens.vue"
export default component.exports